<template>
  <div>
    <div class="titulo-aba">Resumo</div>
    <div class="conteudo-aba">
      <span><strong>Decisão:</strong> {{ obterDecisao() }} <br></span>
      <span v-show="obterDetalhesDecisao()"><strong>Detalhes da Decisão:</strong> {{ obterDetalhesDecisao() }} <br></span>
    </div>
  </div>
</template>

<script>
const SituacaoBmpOrigem = {
  Pendente: 1,
  Aprovado: 2,
  PendenteMesa: 3,
  Negado: 4,
  AguardandoBureau: 5
}

const RESTRICAO_BUREAU = 3
const COMPARATIVO_NAO_CONFORME = 2
const CAMPOS_SITUACAO_BUREAU = [
  'situacaoDataBusca',
  'situacaoObitoFiscal',
  'situacaoCadastroRestritivo',
  'situacaoMidiaDesabonadora',
  'situacaoEmailAge',
  'situacaoCriminalResumo',
  'situacaoCriminalDetalhe',
  'situacaoQuodRufra',
  'situacaoSerproReceita',
  'situacaoDictMed'
]

export default {
  props: {
    onboarding: Object,
    comparativoDados: Array,
    situacaoBmpOrigem: Number
  },
  methods: {
    alimentarObjeto() {
      this.refresh()
    },
    comparativoIncompativel() {
      return Array.isArray(this.comparativoDados) && this.comparativoDados.some(item => item.comparativoBureau === COMPARATIVO_NAO_CONFORME)
    },
    possuiReprovacaoBureaus() {
      const th = this
      return CAMPOS_SITUACAO_BUREAU.some(campo => th.onboarding && th.onboarding[campo] === RESTRICAO_BUREAU)
    },
    possuiReprovacao() {
      return this.possuiReprovacaoBureaus() || this.comparativoIncompativel()
    },
    obterDecisao() {
      const th = this
      const situacao = th.situacaoBmpOrigem

      if (situacao === null || situacao === undefined)
        return th.possuiReprovacao() ? 'Reprovado' : 'Aprovado'

      if (situacao === SituacaoBmpOrigem.Aprovado)
        return 'Aprovado'

      if (situacao === SituacaoBmpOrigem.Negado || th.possuiReprovacao())
        return 'Reprovado'

      if (situacao === SituacaoBmpOrigem.Pendente)
        return th.possuiReprovacao() ? 'Reprovado' : 'Pendente'

      switch (situacao) {
        case SituacaoBmpOrigem.PendenteMesa:
          return 'Pendente de Mesa'
        case SituacaoBmpOrigem.AguardandoBureau:
          return 'Pendente'
        default:
          return 'Pendente'
      }
    },
    obterDetalhesDecisao() {
      const th = this
      const decisao = th.obterDecisao()

      if (decisao === 'Reprovado')
        return 'Reprovado por Políticas Internas. Esta informação é confidencial e não pode ser compartilhada.'

      if (decisao === 'Pendente de Mesa')
        return 'Em análise manual pelo time da BMP. Em breve o status será atualizado.'

      return ''
    },
    refresh() {
      this.$forceUpdate()
    }
  }
}
</script>
<style scoped>
.conteudo-aba span {
  line-height: 1.9;
}
</style>
